import React from 'react';
import TooltipValidator from './TooltipValidator.jsx';

import './style.scss';

let it = 0;

export const merge = {
  TOP: 'top',
  BOTTOM: 'bottom'
};

export default (field) => {
  const name = 'i' + (field.input.name || it++);
  let classes = field.className || '';
  if (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) {
    if (field.meta.valid) {
      classes += ' is-valid';
    } else {
      classes += ' is-invalid';
    }
  }

  let mergeClasses = '';
  if (field.merge === merge.TOP) {
    mergeClasses += ' merge-top';
  } else if (field.merge === merge.BOTTOM) {
    mergeClasses += ' merge-bottom';
  }

  if(field.formGroup) {
    mergeClasses += ' input-group';
  }

  const id = (field.id ? field.id : `${field.meta.form}_${name}`).replace(/\./g, '_');

  return (
    <div className={`form-group${mergeClasses}`}>
      { field.label && <label htmlFor={id}>{field.label}</label> }
      <TooltipValidator field={field} target={id} />
      <select
        multiple={!!field.multiple}
        {...field.input} 
        id={id} 
        placeholder={field.placeholder} 
        className={`form-control ${classes}`}
      >
        {field.children}
      </select>
      {field.formGroup ? (
        <span className="input-group-append">
          {field.formGroup}
        </span>
      ) : ''}
    </div>
  );
};